function XStateContainer({ inclusiveStates = [], exclusiveStates = [], children, currentState }) {
  if (inclusiveStates.length > 0 && !inclusiveStates.includes(currentState)) {
    return null;
  }
  if (exclusiveStates.length > 0 && exclusiveStates.includes(currentState)) {
    return null;
  }
  return <>{children}</>;
}

export default XStateContainer;
